import React from 'react';
import './NavBar.css';

const NavBar = () => {
  return (
    <nav className="nav-bar">
      <ul>
        <li>
          
        </li>
        <li>
          
        </li>
      </ul>
    </nav>
  );
};

export default NavBar;